module.exports = __webpack_public_path__ + "img/H4.28beb013.png";